import type { ApiaUtilTooltips } from './ApiaUtilTooltips';
import { TTooltip } from './tooltip';

let y = 0,
  x = 0;
document?.addEventListener('mousemove', (ev) => {
  x = ev.clientX;
  y = ev.clientY;
});

export class AutomaticTooltip {
  #timeout = 500;
  #tooltipTimeout = 0;
  #unsuscribe: (() => void) | null = null;

  ref = (el: HTMLElement | null) => {
    this.#unsuscribe?.();

    const listener = () => {
      clearTimeout(this.#tooltipTimeout);

      this.#tooltipTimeout = setTimeout(() => {
        if (this.#tooltip?.children)
          this.handler.open({
            closeOnMouseLeaveTooltip: true,
            closeOnEscape: true,
            closeOnScrollOut: true,
            ...this.#tooltip,
            anchorPoint: { left: x + 3, top: y + 3 },
          });
      }, this.#timeout) as unknown as number;
    };

    const reset = () => {
      clearTimeout(this.#tooltipTimeout);
    };

    if (el) {
      el.addEventListener('mousemove', listener);
      el.addEventListener('mouseleave', reset);

      this.#unsuscribe = () => {
        el.removeEventListener('mousemove', listener);
        el.removeEventListener('mouseleave', reset);
      };
    } else {
      this.#unsuscribe?.();
      reset();
    }
  };

  #tooltip: Partial<TTooltip> | null = null;

  constructor(
    tooltip: (Partial<TTooltip> & { timeout?: number }) | null = null,
    private handler: ApiaUtilTooltips,
  ) {
    this.#tooltip = tooltip;
    if (tooltip?.timeout !== undefined) {
      this.#timeout = tooltip?.timeout;
    }
  }

  update = (tooltip: Partial<TTooltip>) => {
    this.#tooltip = tooltip;
  };
}
